import { render, staticRenderFns } from "./coinsTitle.vue?vue&type=template&id=ddedf26e&scoped=true&"
import script from "./coinsTitle.vue?vue&type=script&lang=ts&"
export * from "./coinsTitle.vue?vue&type=script&lang=ts&"
import style0 from "./coinsTitle.vue?vue&type=style&index=0&id=ddedf26e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddedf26e",
  null
  
)

export default component.exports